import { Component } from '@angular/core';
import { ProductMenuFooterComponent } from '../../product-menu-footer.component';

@Component({
  selector: 'app-plantlife-cheap-weed-empty-footer',
  templateUrl: './plantlife-cheap-weed-empty-footer.component.html',
  styleUrls: ['./plantlife-cheap-weed-empty-footer.component.scss'],
  standalone: false
})
export class PlantlifeCheapWeedEmptyFooterComponent extends ProductMenuFooterComponent {}
